<template>
	<div v-if="showResult" class="result-div">
		<h3>{{$t('phone.SuccessTip')}}<span class="text-danger">{{$t('home.Set')}}</span></h3>
		<p><img src="../assets/success.png" height="30" alt=""><b class="text-danger">{{$t('phone.BoundtoMobilephone')}}:</b><span>{{unbind.phone}}</span></p>
		<wd-button type="danger" @click.native="showResult = false" size="large" :styles="{width:'300px'}">{{$t("phone.ChangetheMobilephone")}}</wd-button>
	</div>
	<div id="phone" class="form-container" v-else>
		<template v-if="!unbind.phone">
			<h2>{{$t('phone.MobilePhonebinding')}}</h2>
			<div class="form-item">
				<label for="">{{$t("phone.MobilePhoneNumber")}}</label>
				<input type="text" 
					@focus="validated = false"
					v-model="bind.phone" 
					:class="(validated && !bind.phone) ? 'error' : ''" 
					:placeholder="$t('phone.MobilePhoneNumberTip')" />
			</div>
			<div class="form-item code-item">
				<label for="">{{$t("default.MessageAuthenticationCode")}}</label>
				<input type="text" 
					@focus="validated = false"
					class="code-input" 
					maxlength="6" 
					:class="(validated && !bind.messageAuthenticationCode) ? 'error' : ''" 
					v-model="bind.messageAuthenticationCode" 
					:placeholder="$t('default.VerificationCodeTip')" />
				<span>
					<wd-button 
						:key='codebtnKey'
						ref="bind-btn"
						@click.native="sendCode('bind')"
						type="info" 
						size="small" 
						:styles="{height:'44px'}">{{$t('default.SendVerificationCode')}}</wd-button>
				</span>
			</div>
			<div class="form-item">
				<label for=""></label>
				<wd-button type="danger" @click.native="binding" size="large" :styles="{width:'300px'}">{{$t("default.submit")}}</wd-button>
			</div>
		</template>
		<template v-else>
			<div class="timeline">
				<span class="dot">······</span><span class="des active">1.{{$t('phone.CheckOldPhone')}}</span><span class="dot">······></span><span :class="['des',unbindSuccess?'active':'']">2.{{$t('phone.BindingNewPhone')}}</span><span class="dot">······</span>
			</div>
			<div v-if="!unbindSuccess">
				<h2>{{$t('phone.CheckOldPhone')}}</h2>
				<div class="form-item">
					<label for="">{{$t("phone.MobilePhoneNumber")}}</label>
					<span>{{(unbind.phone).replace(/^(\d{3})\d{4}(\d{4})$/,'$1****$2')}}</span>
					<a :href="'http://www.wooduan.com/service?lang='+($i18n.locale=='zh'?'zh':'en')" target="_blank" style="margin-left: 10px; color: #c72729;font-size: 12px">{{$t('phone.Phonelossorabnormity')}}</a>
				</div>
				<div class="form-item code-item">
					<label for="">{{$t("default.MessageAuthenticationCode")}}</label>
					<input type="text"
						@focus="validated = false" 
						class="code-input" 
						maxlength="6" 
						v-model="unbind.code" 
						:placeholder="$t('default.VerificationCodeTip')" 
						:class="(validated && !unbind.code) ? 'error' : ''" />
					<span>
						<wd-button 
							:key='codebtnKey'
							ref="unbind-btn"
							@click.native="sendCode('unbind')"
							type="info" 
							size="small" 
							:styles="{height:'44px',padding:'5px 15px'}">{{$t('default.SendVerificationCode')}}</wd-button>
					</span>
				</div>
				<div class="form-item">
					<label for=""></label>
					<wd-button type="danger" @click.native="unbinding" size="large" :styles="{width:'300px'}">{{$t("phone.Next")}}</wd-button>
				</div>
			</div>
			<div v-else>
				<h2>{{$t('phone.BindingNewPhone')}}</h2>
				<div class="form-item">
					<label for="">{{$t("phone.BindingNewPhone")}}</label>
					<input type="text" 
						@focus="validated = false"
						v-model="newBind.phone" 
						:class="(validated && !newBind.phone) ? 'error' : ''" 
						:placeholder="$t('phone.MobilePhoneNumberTip')" />
				</div>
				<div class="form-item code-item">
					<label for="">{{$t("default.MessageAuthenticationCode")}}</label>
					<input type="text" 
						@focus="validated = false"
						class="code-input" 
						maxlength="6" 
						:class="(validated && !newBind.code) ? 'error' : ''" 
						v-model="newBind.code" 
						:placeholder="$t('default.VerificationCodeTip')" />
					<span>
						<wd-button 
							:key='codebtnKey'
							ref="exchange-btn"
							@click.native="sendCode('exchange')"
							type="info" 
							size="small" 
							:styles="{height:'44px'}">{{$t('default.SendVerificationCode')}}</wd-button>
					</span>
				</div>
				<div class="form-item">
					<label for=""></label>
					<wd-button type="danger" @click.native="newBinding" size="large" :styles="{width:'300px'}">{{$t("default.submit")}}</wd-button>
				</div>
			</div>
		</template>
	</div>
</template>
<script>
	import WdButton from '@/components/WdButton.vue';
	import VerificationCode from '@/components/VerificationCode.vue';
	export default{
		name:"phone",
		data(){
			return {
				bind:{
					phone:"",
					messageAuthenticationCode:"",
				},
				unbind:{
					phone:"",
					code:"",
				},
				newBind:{
					phone:"",
					code:"",
				},
				validated:false,
				showResult:false,
				unbindSuccess:false,//旧手机解绑成功
				codebtnKey:0
			}
		},
		components:{
			'wd-button':WdButton,
			'v-code':VerificationCode
		},
		methods:{
			async binding(){//绑定
				this.validated = true;
				if(!this.bind.phone){
					this.$alert(this.$t("phone.MobilePhoneNumberTip"))
					return;
				}
				if(!this.bind.messageAuthenticationCode){
					this.$alert(this.$t("default.VerificationCodeTip"))
					return;
				}

				let response = await this.$api.post('/web/index/bindMobilePhone',{phone:this.bind.phone,code:this.bind.messageAuthenticationCode});
				if(response.code == 0){
					this.codebtnKey += 1;
					this.validated = false;
					this.showResult = true;
					this.unbind.phone = this.bind.phone;
					this.$setUser({phone:this.bind.phone});
				}else {
					if(response.code == 420074){
						this.$alert(this.$t('phone.HadBindOther'));
					}else if(response.code == 1016){
						this.$alert(this.$t('phone.PleaseCheckOldPhone'));
					}else if(response.code == 10001){
						this.$alert(this.$t('bind.ParamErr'));
					}else{
						this.$alert(response.msg)
					}
				}
			},
			async unbinding(){//换绑原手机
				this.validated = true;
				if(!this.unbind.phone){
					this.$alert(this.$t("phone.MobilePhoneNumberTip"))
					return;
				}
				if(!this.unbind.code){
					this.$alert(this.$t("default.VerificationCodeTip"))
					return;
				}

				let response = await this.$api.post('/web/index/verifyPhone',{code:this.unbind.code,phone:this.unbind.phone});
				if(response.code == 0){
					this.codebtnKey += 1;
					this.unbindSuccess = true;
					this.validated = false;
					this.unbind.code = '';
				}else{
					if(response.code == 420074){
						this.$alert(this.$t('phone.HadBindOther'));
					}else if(response.code == 1016){
						this.$alert(this.$t('phone.PleaseCheckOldPhone'));
					}else{
						this.$alert(response.msg)
					}
				}
			},
			async newBinding(){//绑定新手机
				this.validated = true;
				if(!this.newBind.phone){
					this.$alert(this.$t("phone.MobilePhoneNumberTip"))
					return;
				}
				if(!this.newBind.code){
					this.$alert(this.$t("default.VerificationCodeTip"))
					return;
				}

				let response = await this.$api.post('/web/index/exchangePhone',{code:this.newBind.code,phone:this.newBind.phone});
				if(response.code == 0){
					this.codebtnKey += 1;
					this.unbind.phone = this.newBind.phone;
					this.unbindSuccess = false;
					this.showResult = true;
					this.$setUser({phone:this.newBind.phone});
					this.validated = false;
					this.newBind.phone = '';
					this.newBind.code = '';
				}else {
					if(response.code == 420074){
						this.$alert(this.$t('phone.HadBindOther'));
					}else if(response.code == 1016){
						this.$alert(this.$t('phone.PleaseCheckOldPhone'));
					}else{
						this.$alert(response.msg)
					}
				}
			},
			sendCode(type){ //获取手机验证码
				if(type == 'bind'){
					this.$refs[type+'-btn'].sendMessageCode('bind',this.bind.phone);
				}else if(type == 'unbind'){
					this.$refs[type+'-btn'].sendMessageCode('unbind',this.unbind.phone);
				}else if(type == 'exchange'){
					this.$refs[type+'-btn'].sendMessageCode('exchange',this.newBind.phone);
				}
			}
		},

		async created(){
			let user = await this.$getUser();
			if(user){
				this.unbind.phone = user.phone;
			}
		}
	}
</script>
<style scoped>
	.form-container{
		margin-top: 50px;
	}
	.timeline{
		text-align: center;
		margin-bottom: 40px;
	}
	.timeline .dot {
		color: #666;
	}
	.timeline .des {
		margin: 0 10px;
		color: #666;
		font-size: 16px;
	}
	.timeline .des.active{
		color: #ce292d;
	}
</style>
